// extracted by mini-css-extract-plugin
export default {"wrapper":"statut_wrapper__-H38D"};